import firebase from 'firebase/app';
import '@firebase/messaging';
import { firebaseConfig } from './fbConfigs';
import { setStorage, getUserGroupData } from '../utils/browserStorage';

// import {userGroupUrlCheck} from '../utils/userGroupUrlCheck';
// import {LBL_APP_NAME} from '../configs/labelConfigs';
import * as notificationUrls from '../configs/notificationConfigs';
import { notificationReadAction } from '../actions/fcmActions'
//import { connect } from 'react-redux';
import configureStore from '../store/configureStore';
const store = configureStore();

export const initializeFirebase = () => {

  // let userGroupData = userGroupUrlCheck(this.props.location);

  firebase.initializeApp(firebaseConfig);

  const messaging = firebase.messaging();

  // messaging.usePublicVapidKey("BKOjGF19PucjJNGR62WiR1hc8qBbZiFPq-TKBnKAOUsASYk0U65_OSCSCTQMPxhvDfsc1G9PmZtIzsg-WrLyHMg");
  messaging.usePublicVapidKey("BGP7HygMJgAeowcJcIBWJbG7pXywvqtr6NJegrWwTJfTOCG7WRZ-qj32DjzOZ3llkW6wLGVHJvyWvwHPIrEkfCo");
  //--------------------------//
  //Production Configurations //
  //--------------------------//
  //messaging.usePublicVapidKey("BChIRt-mk3T1gxbP4yN9Z4vpbUG0NlTmyVnjpON_R8m-ZYz6pCyk_Z_Cpzx0XGn2Un25HK67936P-TuMW_Bn4xY");

  messaging.requestPermission()
    .then(function () {
      console.log("Have Push Notification Permission");
      return messaging.getToken();
    })
    .then(function (token) {
      console.log('fcmNotificationToken: ' + token);
      setStorage('fcmNotificationToken', token);
    })
    .catch(function (err) {
      console.log("Denied Push Notification Permission", err);
    })

  messaging.onMessage(function (payload) {
    console.log('Message received. ');
    console.log(payload);
    const title = (payload.data && payload.data.title) ? payload.data.title : ''; // LBL_APP_NAME;
    const options = {
      body: payload.data.notification_string,
      icon: '/logo_small.png'
    };
    var notification = new Notification(title, options);

    // INCREMENT THE NOTIFICATION COUNT
    let notificationCount = 0;
    let userGroupDataAffiliate = [];
    let userGroupDataClient = [];
    let group = ''
    notification.onshow = function () {

      userGroupDataAffiliate = getUserGroupData('affiliate');
      if (userGroupDataAffiliate !== null) {
        group = 'affiliate'
        if (payload.data.notification_count != undefined) {
          userGroupDataAffiliate.notification_count = payload.data.notification_count;
        } else {
          userGroupDataAffiliate.notification_count++;
        }
        setStorage('affiliate', JSON.stringify(userGroupDataAffiliate));
        notificationCount = userGroupDataAffiliate.notification_count;
        console.log('affiliate notificationCount: ' + notificationCount + ', user_notif_id: ' + payload.data.user_notif_id)
      }

      userGroupDataClient = getUserGroupData('client');
      if (userGroupDataClient !== null) {
        group = 'client'
        if (payload.data.notification_count != undefined) {
          userGroupDataClient.notification_count = payload.data.notification_count;
        } else {
          userGroupDataClient.notification_count++;
        }
        setStorage('client', JSON.stringify(userGroupDataClient));
        notificationCount = userGroupDataClient.notification_count;
        console.log('client notificationCount: ' + notificationCount + ', user_notif_id: ' + payload.data.user_notif_id)
      }

      // setTimeout(console.log('aaa'), 3000000);
    };

    notification.onclick = function (event) {
      store.dispatch(notificationReadAction({ id: payload.data.user_notif_id }));
      event.preventDefault();

      let id = null;
      let action = payload.data.action;

      let OT_OE_Actions_Arr = ['ot_request', 'ot_request_by_crew', 'ot_request_by_chief', 'ot_request_by_crew_chief', 'oe_request', 'oe_request_by_crew', 'oe_request_by_chief', 'oe_request_by_crew_chief'];

      if (OT_OE_Actions_Arr.includes(action)) {
        action = action + '_' + group;
      }
      console.log('action: ' + action);
      let url = notificationUrls[action];
      if (notificationUrls.notifiActionDictionary.hasOwnProperty(payload.data.action) != -1) {
        if (notificationUrls.notifiActionDictionary[payload.data.action] == "") {
          id = ""
        } else {
          id = payload.data[notificationUrls.notifiActionDictionary[payload.data.action]];
        }

      } else {
        id = payload.data.event_id;
      }
      if (!id) id = '';
      console.log(url + id)
      window.open(url + id, '_blank');
      window.focus();
    };
  });

}


